import { styled, Box } from '@mui/material';

const Container = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
}));

const InnerContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'spacingBottom' && prop !== 'spacingBottomXs',
})<{
  textalign: 'center' | 'unset';
  alignitems: 'center' | 'unset';
  spacingBottom: number;
  spacingBottomXs: number;
}>(({ theme, textalign, alignitems, spacingBottom = 7, spacingBottomXs = 3 }) => ({
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: theme.breakpoints.values.lg,
  display: 'flex',
  flexDirection: 'column',
  alignItems: alignitems,
  padding: `${theme.spacing(7)} ${theme.spacing(3)} ${theme.spacing(spacingBottom)}`,
  textAlign: textalign,
  [theme.breakpoints.down('sm')]: {
    padding: `${theme.spacing(3)} ${theme.spacing(1)} ${theme.spacing(spacingBottomXs)}`,
  },
}));

interface Props {
  children?: React.ReactNode;
  backgroundColor?: string;
  fontSize?: number;
  textAlign?: 'center' | 'unset';
  alignItems?: 'center' | 'unset';
  spacingBottom?: number;
  spacingBottomXs?: number;
  className?: string;
  id?: string;
}

export const BlockContainer = ({
  children,
  backgroundColor,
  textAlign = 'unset',
  alignItems = 'unset',
  fontSize = 14,
  spacingBottom = 7,
  spacingBottomXs = 3,
  className,
  id,
}: Props) => (
  <Container
    id={id}
    sx={{
      backgroundColor: backgroundColor,
      fontSize,
    }}
    className={className}
  >
    <InnerContainer
      textalign={textAlign}
      alignitems={alignItems}
      spacingBottom={spacingBottom}
      spacingBottomXs={spacingBottomXs}
    >
      {children}
    </InnerContainer>
  </Container>
);
